import { Shield, FileCheck } from 'lucide-react';

const PlayerPassportPreview = () => {
  const tabs = ['Achievements', 'Passport', 'Portfolio', 'Stats'];
  const activeTab = 1; // Passport tab active

  const stats = {
    matchesPlayed: 45,
    totalGoals: 23,
    totalAssists: 15,
    minutes: 3450
  };

  const timeline = [
    {
      club: "Manchester Youth FC",
      role: "U-18 Academy",
      date: "Joined Jan 2023",
      status: "completed"
    },
    {
      club: "Elite Sports Academy",
      role: "Current Club",
      date: "Joined Aug 2024",
      status: "active"
    }
  ];

  return (
    <div className="w-full max-w-[600px] bg-card rounded-2xl border border-border shadow-premium-xl overflow-hidden">
      {/* Tab Navigation */}
      <div className="flex gap-1.5 sm:gap-2 p-3 sm:p-4 border-b border-border bg-muted/30 overflow-x-auto">
        {tabs.map((tab, index) => (
          <button
            key={tab}
            className={`px-2.5 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-medium transition-all whitespace-nowrap ${
              index === activeTab
                ? 'bg-accent text-accent-foreground'
                : 'bg-muted/50 text-muted-foreground hover:bg-muted'
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Content Grid - Stacks on mobile */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 p-3 sm:p-4">
        {/* Left Column */}
        <div className="space-y-3 sm:space-y-4">
          {/* Profile Card */}
          <div className="bg-muted/30 rounded-xl p-3 sm:p-4 border border-border/50">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gradient-to-br from-accent to-accent-soft flex items-center justify-center text-accent-foreground font-bold text-base sm:text-lg">
                I
              </div>
              <div>
                <h3 className="font-bold text-foreground text-sm sm:text-base">Ilham</h3>
                <p className="text-xs sm:text-sm text-muted-foreground">Malaysia</p>
              </div>
            </div>
            <div className="flex gap-1.5 sm:gap-2 flex-wrap">
              <span className="inline-flex items-center gap-1 sm:gap-1.5 px-2 sm:px-2.5 py-0.5 sm:py-1 rounded-full bg-emerald-500/20 text-emerald-400 text-[10px] sm:text-xs font-medium">
                <Shield className="w-2.5 h-2.5 sm:w-3 sm:h-3" />
                Verified Profile
              </span>
              <span className="inline-flex items-center gap-1 sm:gap-1.5 px-2 sm:px-2.5 py-0.5 sm:py-1 rounded-full bg-teal-500/20 text-teal-400 text-[10px] sm:text-xs font-medium">
                <FileCheck className="w-2.5 h-2.5 sm:w-3 sm:h-3" />
                Medical Clearance
              </span>
            </div>
          </div>

          {/* Career Statistics */}
          <div className="bg-muted/30 rounded-xl p-3 sm:p-4 border border-border/50">
            <h4 className="text-xs sm:text-sm font-semibold text-muted-foreground mb-3 sm:mb-4">Career Statistics</h4>
            <div className="grid grid-cols-2 gap-3 sm:gap-4">
              <div>
                <p className="text-2xl sm:text-3xl font-bold text-foreground">{stats.matchesPlayed}</p>
                <p className="text-[10px] sm:text-xs text-muted-foreground">Matches Played</p>
              </div>
              <div>
                <p className="text-2xl sm:text-3xl font-bold text-foreground">{stats.totalGoals}</p>
                <p className="text-[10px] sm:text-xs text-muted-foreground">Total Goals</p>
              </div>
              <div>
                <p className="text-2xl sm:text-3xl font-bold text-foreground">{stats.totalAssists}</p>
                <p className="text-[10px] sm:text-xs text-muted-foreground">Total Assists</p>
              </div>
              <div>
                <p className="text-2xl sm:text-3xl font-bold text-foreground">{stats.minutes.toLocaleString()}</p>
                <p className="text-[10px] sm:text-xs text-muted-foreground">Minutes</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Timeline */}
        <div className="bg-muted/30 rounded-xl p-3 sm:p-4 border border-border/50">
          <h4 className="text-xs sm:text-sm font-semibold text-muted-foreground mb-3 sm:mb-4">Career Timeline</h4>
          <div className="relative">
            {/* Timeline Line */}
            <div className="absolute left-[7px] top-2 bottom-2 w-0.5 bg-border" />
            
            <div className="space-y-3 sm:space-y-4">
              {timeline.map((entry, index) => (
                <div key={index} className="relative pl-5 sm:pl-6">
                  {/* Timeline Dot */}
                  <div className={`absolute left-0 top-1.5 w-3 h-3 sm:w-4 sm:h-4 rounded-full border-2 ${
                    entry.status === 'active' 
                      ? 'bg-emerald-500 border-emerald-400' 
                      : 'bg-muted-foreground/30 border-muted-foreground/50'
                  }`} />
                  
                  <div>
                    <h5 className="font-semibold text-foreground text-xs sm:text-sm">{entry.club}</h5>
                    <p className="text-[10px] sm:text-xs text-muted-foreground">{entry.role}</p>
                    <p className="text-[10px] sm:text-xs text-muted-foreground mt-0.5 sm:mt-1">{entry.date}</p>
                    <span className={`inline-block mt-1.5 sm:mt-2 px-1.5 sm:px-2 py-0.5 rounded text-[10px] sm:text-xs font-medium ${
                      entry.status === 'active'
                        ? 'bg-emerald-500/20 text-emerald-400'
                        : 'bg-muted text-muted-foreground'
                    }`}>
                      {entry.status === 'active' ? 'Active' : 'Completed'}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayerPassportPreview;
